import React from 'react';
import { Phone } from 'lucide-react';

/**
 * "Call Customer" button — uses the universal `tel:` URI which:
 *   - Mobile: opens the dialer with the number pre-filled
 *   - Desktop: opens the system phone app (Mac Phone, Windows Skype, etc.)
 *
 * Designed to visually match ViewMapButton so the two sit side-by-side
 * consistently in agent/partner booking cards.
 */
const sanitizePhone = (raw) => {
  if (!raw) return '';
  // Keep digits and a leading "+". Strip everything else (spaces, dashes, parens).
  const trimmed = String(raw).trim();
  const sign = trimmed.startsWith('+') ? '+' : '';
  return sign + trimmed.replace(/\D/g, '');
};

export const CallCustomerButton = ({
  phone,
  size = 'sm',
  className = '',
  label = 'CALL CUSTOMER',
}) => {
  const dial = sanitizePhone(phone);
  if (!dial) return null;

  const padding = size === 'xs' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-1 text-xs';
  const iconSize = size === 'xs' ? 10 : 12;

  return (
    <a
      href={`tel:${dial}`}
      data-testid="call-customer-btn"
      title={`Call ${phone}`}
      className={`inline-flex items-center gap-1 ${padding} border-2 border-black bg-white hover:bg-[#00C853] hover:text-white font-mono uppercase font-bold tracking-wide transition-colors whitespace-nowrap ${className}`}
    >
      <Phone size={iconSize} />
      {label}
    </a>
  );
};

export default CallCustomerButton;
